<template>
  <v-app>
    <Loader />
    <custom-notification />
    <custom-confirmation />
    <side-bar :drawer="drawer" />
    <top-nav :drawer.sync="drawer" />
    <slot />
  </v-app>
</template>
<script>
import { SideBar, TopNav, Loader } from '@/layouts';
import CustomConfirmation from '@/notifications/confirmation';

export default {
  components: { SideBar, TopNav, Loader, CustomConfirmation },
  data() {
    return { drawer: true };
  },
};
</script>
